import {verifyToken} from "../../utils/API";

export const VERIFY_REQUEST = 'push/VERIFY_REQUEST';
export const VERIFY_SUCCESS = 'push/VERIFY_SUCCESS';
export const VERIFY_CANCEL = 'push/VERIFY_CANCEL';
export const VERIFY_FAIL = 'push/VERIFY_FAIL';

const initialState = {
    loading: false,
    token: null,
    verified: false,
    error: null,
    canceled: false,
};

export default (state = initialState, {type, ...args}) => {
    const {token, error} = args;

    switch (type) {
        case 'RESET':
            return {
                ...initialState
            };
        case VERIFY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                canceled: false,
                token,
            };
        case VERIFY_SUCCESS:
            return {
                ...state,
                loading: false,
                verified: !!state.token,
                canceled: false,
                error: null,
            };
        case VERIFY_FAIL:
            return {
                ...state,
                loading: false,
                verified: false,
                error: error || 'Unknown error',
                canceled: false,
                token: null,
            };
        case VERIFY_CANCEL:
            return {
                ...state,
                canceled: true,
            };
        default:
            return state;
    }
}


let verifyTimer = null;

export const verifyTokenRequest = (token, timeout = 30000) => {
    return async (dispatch) => {
        dispatch({
            type: VERIFY_REQUEST,
            token,
        });

        try {
            await verifyToken(token);

            !!verifyTimer && clearTimeout(verifyTimer);
            verifyTimer = setTimeout(() => {
                dispatch({
                    type: VERIFY_FAIL,
                    error: 'TOKEN_VERIFY_TIMEOUT',
                });
            }, timeout);

        } catch(e) {
            dispatch({
                type: VERIFY_FAIL,
                error: 'TOKEN_INVALID',
            });
        }
    }
};

export const verifyTokenSuccess = () => {
    return async (dispatch) => {
        !!verifyTimer && clearTimeout(verifyTimer);

        dispatch({
            type: VERIFY_SUCCESS,
        });
    }
};

export const verifyTokenCancel = () => {
    return async (dispatch) => {
        !!verifyTimer && clearTimeout(verifyTimer);

        dispatch({
            type: VERIFY_CANCEL,
        });
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/push.js